import React, {useEffect, useState}  from 'react';
import VideosHeader from './VideosHeader';
import VideoList from './VideoList';
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import { getVideosForAdmin, executeAdminFilter, executeAdminSearch, getVideosLength, getVideosOff, getVideosLengthForFilter, getVideosLengthForSearch, getVideosOffLength } from '../../actions/videoActions';


const AdminVideos = (props) => {

    const dispatch = useDispatch()

    const [videoList, setVideoList] = useState([])

    const [initialPage, setInitialPage] = useState(1)

    const [stateChanged, setStateChanged] = useState(false)

    const { adminVideos, videosLength, adminVideosLoading } = useSelector(state=>state.adminVideos)

    const handlePageClick = (event) => {
        props.setPage(event.selected+1)
    }

    useEffect(()=>{
        setInitialPage(props.page-1)
        if(props.index){
            if (props.index === 1){
                dispatch(getVideosLength())
                dispatch( getVideosForAdmin( props.page ) )
            } else if (props.index === 2 && props.filterList.length){
                dispatch( getVideosLengthForFilter( props.filterList ) )
                dispatch( executeAdminFilter( props.filterList, props.page ) )
            } else if (props.index === 3 && props.searchValue.length){
                dispatch( getVideosLengthForSearch( props.searchValue ) )
                dispatch( executeAdminSearch( props.searchValue, props.page ) )
            } else if (props.index === 4 ){
                dispatch( getVideosOffLength() )
                dispatch( getVideosOff( props.page, 4 ) )
            }
        } else {
            dispatch( getVideosLength() )
            dispatch( getVideosForAdmin( 1, 1 ) )
        }

    },[props.page, props.index, stateChanged])

    return (
        <div className = 'px-5 py-5 col-10' style={{marginLeft:'15vw', minHeight:"100vh"}}>
            <VideosHeader
                filterList = {props.filterList}
                setFilterList = {props.setFilterList}
                searchValue = {props.searchValue}
                setSearchValue = {props.setSearchValue}
                setPage = {props.setPage}
                videoList = {videoList}
                setIndex = {props.setIndex}
                setStateChanged = {setStateChanged}
                stateChanged = {stateChanged}
            />
            {
                adminVideosLoading ? 
                <div className='py-5 text-info fs-2'>Loading...</div> : 
                <VideoList
                    videos = {adminVideos}
                    index = {props.index}
                    setVideoList = {setVideoList}
                    videoList = {videoList}
                />
            }
            {
                videosLength &&  
                <div className = 'd-flex justify-content-end bg-warning pb-5'>
                    <ReactPaginate
                        breakLabel="..."
                        nextLabel=">>"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={3}
                        pageCount={Math.ceil(videosLength/10)}
                        previousLabel="<<"
                        renderOnZeroPageCount={null}
                        marginPagesDisplayed = {1}
                        forcePage={initialPage}
                        containerClassName = "d-flex py-2 col-4 justify-content-end"
                        pageClassName = 'text-info col-1 py-1 rounded bg-success border border-secondary list-unstyled m-1 text-center'
                        previousClassName = 'text-info col-1 py-1 rounded bg-success border border-secondary list-unstyled m-1 text-center'
                        previousLinkClassName = 'text-info col-1 py-1 rounded bg-success text-decoration-none m-1 text-center'
                        nextClassName = 'text-info col-1 py-1 rounded bg-success border border-secondary list-unstyled m-1 text-center'
                        nextLinkClassName = 'text-info col-1 py-1 rounded bg-success text-decoration-none m-1 text-center'
                        breakClassName = 'col-1 text-info list-unstyled d-flex align-items-end justify-content-center fs-2'
                        activeClassName = 'bg-info text-white'
                    />
                </div> 
            }
        </div>
    );
};

export default AdminVideos;